<template>
    <div class="conf-wrp">
        <div class="content-wrp">
            <div class="content">
                <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
                    <section>
                        <div class="title">
                            <span>基础设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="标题设置:" prop="titleSet">
                                <el-checkbox v-model="value.titleSet">商品标题超过平台限制自动截断（最多60个字符）</el-checkbox>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>库存设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="铺货时，进行库存默认设置:" >
                                <el-switch v-model="checkInstock"></el-switch>
                            </el-form-item>
                            <el-form-item v-if="checkInstock" label="库存默认值" prop="instock">
                                <div class="instock">
                                    <span class="prev">铺货到淘特到SKU库存默认值&nbsp;=&nbsp;</span>
                                    <el-input v-model="value.instock" style="width: 120px" placeholder="请输入库存数"></el-input>
                                    <span class="tips">&nbsp;(此值应用于商品铺货时，对商品各SKU的库存初始化值，最大值为99999)</span>
                                </div>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>运费模板设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                                <div class="ship-wrp" v-if="shopList.length > 0">
                                    <div class="item" v-for="(item, idx) in shopList" :key="idx">
                                        <div class="shopname">
                                            <img class="shop-img" :src="item.icon"/>
                                            <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                                                <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                                            </el-tooltip>
                                            <span>{{ item.shortTitle || item.title }}</span>
                                        </div>
                                        <el-select 
                                            :loading="selectLoading" 
                                            v-model="shipsValue[item.id]" 
                                            placeholder="请选择运费模板" 
                                            clearable
                                            @visible-change="changeSelect(item.id, item.userId)"
                                            width="150px">
                                            <el-option
                                                v-for="ship in shipsTemplate[item.id]"
                                                :key="ship.id"
                                                :label="ship.name"
                                                style="width: 150px;"
                                                :title="ship.name"
                                                :value="ship.id">
                                            </el-option>
                                        </el-select>
                                        <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div>
                                    </div>
                                </div>
                                <span v-else class="no-shops">暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>上架设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="上架设置:" prop="shelfType">
                                <el-radio-group v-model="value.shelfType">
                                    <el-radio :label="1">立即上架</el-radio>
                                    <!-- <el-radio :label="3">定时上架</el-radio> -->
                                    <el-radio :label="2">放入草稿箱</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </section>
                    <PriceConf ref="PriceConfRef" platform="tjb" :priceList="value.price"></PriceConf>
                    <div class="btns">
                        <el-button type="primary" @click="save">保存模板</el-button>
                        <el-button @click="back">返回</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import '@/assets/css/prod.scss';
import {getDistributionConfig, updateDistributionConfig, getTTeTemplateList} from '@servers/prod/conf/index.js'
import PriceConf from './components/PriceConf.vue';

const PLATFORMID = 'tjb';

export default {
    props: {
        back: Function
    },
    components: {
        PriceConf
    },
    data() {
        const validateInstock = (rule, value, callback) => {
            const reg = /^[0-9]*$/;
            if (value === '') {
                callback(new Error('请输入库存数'));
            } else if (!reg.test(value)) {
                callback(new Error('库存数必须是数字, 且为整数'))
            } else if (value <= 0 || value >= 99999) {
                callback(new Error('库存数必须为0-99999之间的整数'))
            } else {
                callback();
            }
        }
        return {
            checkInstock: false,
            shopList: [],
            value: {
                titleSet: true,
                instock: null,
                shelfType: 1
            },
            selectLoading: false,
            rules: {
                instock: [
                    {required: true, message: '请输入库存数'},
                    {validator: validateInstock}
                ],
                shelfType: [
                    {required: true, message: '请输入上架设置'},
                ]
            },
            shipsValue: {// 运费模板
            },
            shipsTemplate: { // 运费模板列表

            }
        }
    },
    mounted() {
        this.getConf();
    },
    methods: {
        async getConf() {
            const res = await getDistributionConfig({shopType: PLATFORMID});
            const shopList = this.$store.getters.get_AllShops_BySource('tjb');
            this.shopList = shopList;
            if (res) {
                this.checkInstock = res.isCommodityStock === 1;
                this.value.titleSet = res.isCommodityTitle === 1;
                this.value.instock = res.stockNumber;
                this.value.shelfType = res.shelfState;
                this.value.price = res.price ? JSON.parse(res.price) : [];
            }
            this.intiTemplate(shopList, res && res.templateList);
        },
        async getTemplateList(userId) {
            const list = await getTTeTemplateList({userId: userId});
            if (list) {
                return list.map(ship => {
                    return {
                        name: ship.name,
                        id: ship.templateId
                    }
                });
            }
            return [];
        },
        async refreshTemplate(shopId, userId) {
            this.selectLoading = true;
            const list = await this.getTemplateList(userId);
            this.shipsTemplate[shopId] = list;
            const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
            if (idx === -1) {
                this.shipsValue[shopId] = '';
            }
            this.selectLoading = false;
            this.$message.success('刷新模板成功');
        },
        intiTemplate(shopList, templateList=[]) {
            const ships = {};
            const shopUserIdMap = {};
            for(let shop of shopList) {
                ships[shop.id] = '';
                shopUserIdMap[shop.userId] = shop.id;
                this.shipsTemplate[shop.id] = [];
            }
            const shipsTemp = {};
            if (shopList.length && templateList) {
                    templateList.forEach(item => {
                        item.shopId = shopUserIdMap[item.shopId] || item.shopId;
                        ships[item.shopId] = item.templateId;
                        if (this.shipsTemplate[item.shopId] && !this.shipsTemplate[item.shopId].length) {
                            shipsTemp[item.shopId] = [{name: item.templateName, id: item.templateId}]
                        }
                    })
            }
            this.shipsTemplate = shipsTemp;
            this.shipsValue = ships;
        },
        async changeSelect(shopId, userId) {
            if (!this.shipsTemplate[shopId] || !this.shipsTemplate[shopId].length ||
                (this.shipsTemplate[shopId].length === 1 && this.shipsTemplate[shopId][0].id === this.shipsValue[shopId])) {
                this.selectLoading = true;
                const list = await this.getTemplateList(userId)
                const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
                if (idx === -1) {
                    this.shipsValue[shopId] = '';
                }
                this.shipsTemplate[shopId] = list;
                this.selectLoading = false;
            }
        },
        findTemplateName(shopid, tempId) {
            if (!this.shipsTemplate[shopid]) return '';
            for(let item of this.shipsTemplate[shopid]) {
                if (item.id === tempId) {
                    return item.name;
                }
            }
        },
        save() {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    const {
                        titleSet,
                        imgNumSet,
                        instock,
                        shelfType
                    } = this.value;
                    const templateList = []
                    Object.keys(this.shipsValue).forEach(id => {
                        const name = this.findTemplateName(id, this.shipsValue[id]);
                        const channel = this.shopList.find(shop => shop.id == id)?.channel
                        // if (this.shipsValue[id] && name) {
                            templateList.push({
                                shopId: id,
                                templateId: this.shipsValue[id] || null,
                                templateName: name || null,
                                channel
                            });
                        // }
                    });
                    const res = await updateDistributionConfig({
                        shopType: PLATFORMID,
                        isCommodityTitle: titleSet ? 1 : 0,
                        isCommodityImage: imgNumSet ? 1 : 0,
                        isCommodityStock: this.checkInstock ? 1 : 0,
                        stockNumber: this.checkInstock ? `${instock === null ? '' : instock}` : '',
                        shelfState: shelfType,
                        templateList: templateList,
                        price: JSON.stringify(this.$refs.PriceConfRef.getData())
                    });
                    if (res) {
                        this.$message.success('保存成功');
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss">

</style>